module.exports = __webpack_public_path__ + "static/media/Products (3).2a40707d.png";